export function openWindow(url: string) {
  window.open(url, "_blank")?.focus();
}

export function isHttps() {
  return document.location.protocol === "https:";
}

/**
 * Extracts the root domain from a host string, specifically for PushPress domains
 * @param host - The host string to extract the domain from (e.g. "app.pushpress.com",
 * "y5dfg32.pushpressdev.com", "pushpress.com")
 * @returns The root domain (e.g. "pushpress.com", "pushpressdev.com")
 */
export const getRootDomain = (host: string) => {
  const rootDomainMatch = host.match(/pushpress(dev|stage|local)?\.com/);
  return rootDomainMatch ? rootDomainMatch[0] : "pushpress.com";
};

/**
 * Extracts the subdomain(s) from the current hostname. If there are mutliple
 * subdomains, it will return an array of subdomains.
 * @returns The subdomain(s). For example, "some.app.pushpress.com" it will
 * return ["some", "app"]. "pushpress.com" will return [].
 */
export const getSubdomains = (): string[] => {
  const hostname = window.location.hostname;
  const ipAddressRegex = /^\d+\.\d+\.\d+\.\d+$/;

  if (hostname === "localhost" || ipAddressRegex.test(hostname)) {
    return [];
  }

  const domainSegments = hostname.split(".");
  const doesNotHaveSubdomain = domainSegments.length <= 2;

  if (doesNotHaveSubdomain) {
    return [];
  }

  const extractedSubdomains = domainSegments.slice(0, -2);
  return extractedSubdomains;
};
